<template>
<div>
  <h1>SiteGrader Order</h1>
</div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Order',
  data () {
    return {
      results: [],
      order: null
    }
  },
  methods: {
    getOrderResults (orderId) {
      axios.get('/toolbox/seo/site-grader/order/' + orderId)
        .then(r => {
          this.order = r.data.data.order
          this.results = r.data.data.results
        })
        .catch(e => {
          this.$toastr.error(e, 'QQ...')
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pages/Std/SiteGrader/Order.vue